import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import { StoreTypeDto } from '../models/store.models';
import { ApiService } from './api.service';

export interface CreateStoreTypeRequest {
  name: string;
  code: string;
  icon?: string | null;
}

export interface UpdateStoreTypeRequest {
  name: string;
  icon?: string | null;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class StoreTypesService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/SuperAdmin/store-types`;
  private readonly publicEndpoint = `${environment.apiUrl}/api/Stores/types`;

  getAll(activeOnly = true): Observable<ApiResponse<StoreTypeDto[]>> {
    if (activeOnly) {
      return this.http.get<ApiResponse<StoreTypeDto[]>>(this.publicEndpoint);
    }
    const params = new HttpParams().set('activeOnly', 'false');
    return this.http.get<ApiResponse<StoreTypeDto[]>>(this.endpoint, { params });
  }

  create(data: CreateStoreTypeRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.endpoint, data);
  }

  update(id: string, data: UpdateStoreTypeRequest): Observable<ApiResponse<unknown>> {
    return this.http.put<ApiResponse<unknown>>(`${this.endpoint}/${id}`, data);
  }

  delete(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.endpoint}/${id}`);
  }
}
